var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons8-checked (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zz",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Driver-All-Checked",
    transform: "translate(-258.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-checked-(2)",
    transform: "translate(258.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,20 C40,31.045 31.045,40 20,40 C8.955,40 0,31.045 0,20 C0,8.955 8.955,0 20,0 C31.045,0 40,8.955 40,20 Z",
    id: "Path",
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4CAF50",
    points: "30.586 10.586 17.016 24.172 11.414 18.586 8.586 21.414 17.02 29.828 33.415 13.414"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChecked);
export default __webpack_public_path__ + "static/media/greenChecked.bba4c645fb81f35c7431a1ee8d27a5dd.svg";
export { ForwardRef as ReactComponent };